import React, { createContext } from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';


const { Consumer, Provider } = createContext({});

export const withSlide = Child => {
  return class extends React.Component {
    static displayName = 'slideProvider(' + Child.displayName + ')';
    
    render() {
      return (
        <Consumer>
          {slide => <Child {...this.props} subscribe={slide.subscribe} next={slide.next} prev={slide.prev} goTo={slide.goTo}/>}
        </Consumer>
      );
    }
  };
};


class SlideProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slides: []
    };
  }
  
  subscribe = (slide) => {
    this.setState(state => {
      return {
        slides: [...state.slides, slide]
      };
    });
  };

  next = (group) => {
    this.state.slides.forEach(slide => {
      if(slide.group === group) {
        slide.handler.next();
      }
    });
  };

  prev = (group) => {
    this.state.slides.forEach(slide => {
      if(slide.group === group) {
        slide.handler.prev();
      }
    });
  };

  goTo = (group, position) => {
    this.state.slides.forEach(slide => {
      if(slide.group === group) {
        slide.handler.goTo(position);
      }
    });
  };

  render() {
    const { children } = this.props;    
    return (
      <React.Fragment>
        <Provider
        value={{
          ...this.props.config,
          subscribe: this.subscribe,
          next: this.next,
          prev: this.prev,
          goTo: this.goTo
        }}>
        {children}
        </Provider>
      </React.Fragment>
    );
  }
}

export default compose(
  PropertyManager([]),
)(SlideProvider);
